export default "__VITE_ASSET__C2msJRrE__$_?url__"